import { render, staticRenderFns } from "./teamtop.vue?vue&type=template&id=d5b75fa8&scoped=true"
import script from "./teamtop.vue?vue&type=script&lang=js"
export * from "./teamtop.vue?vue&type=script&lang=js"
import style0 from "./teamtop.vue?vue&type=style&index=0&id=d5b75fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b75fa8",
  null
  
)

export default component.exports